export var MULTICALL_ADDRESS = '0x5ba1e12693dc8f9c48aad8770482f4739beed696';
export var MULTICALL_ADDRESSES = [
    { address: MULTICALL_ADDRESS, chainId: 1 },
    { address: '0x1F98415757620B543A52E61c46B32eB19261F984', chainId: 10 },
    { address: '0xBF69a56D35B8d6f5A8e0e96B245a72F735751e54', chainId: 42161 },
    { address: '0x091e99cb1C49331a94dD62755D168E941AbD0693', chainId: 8453 },
    { address: MULTICALL_ADDRESS, chainId: 11155111 },
];
export var WETH_ADDRESSES = [
    { address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', chainId: 1 },
    { address: '0x4200000000000000000000000000000000000006', chainId: 10 },
    { address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', chainId: 42161 },
    { address: '0x4200000000000000000000000000000000000006', chainId: 8453 },
    { address: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14', chainId: 11155111 },
];
// Convert WETH_ADDRESSES array to a map
export var WETH_ADDRESS_MAP = WETH_ADDRESSES.reduce(function (map, _a) {
    var address = _a.address, chainId = _a.chainId;
    map[chainId] = address;
    return map;
}, {});
